import { fetchSeoLinks } from '../../dataSource/seo/seo.request'
import { renderPage } from '../../domain/home/home.page'
import { localeCountryIsBelgium, localeCountryIsFrance } from '../../domain/i18n'
import {
  COUNT_CITIES_FOOTER_HP,
  COUNT_CITIES_TO_DISCOVER,
  FRONT_SERVICES_LINK_HP
} from '../../domain/seo/seo.constants'
import { resetAddress } from '../../store/address/addressSlice'
import { setItineraryDepartureNow } from '../../store/itineraryOptions/itineraryOptionsSlice'
import { activateGeoIp } from '../../store/map/mapSlice'
import { selectLocale } from '../../store/navigation/navigation.selectors'
import {
  loadCompleteGeoentitiesAtAddressConfiguration,
  loadPoiAssetsConfiguration
} from '../../store/poiassets/poiassets.actions'
import { resetSearchTerms } from '../../store/search/searchSlice'
import { loadCitiesToDiscover, searchFirstCities } from '../../store/seo/seo-address.actions'
import { loadFakeActivitiesForHp, loadTopSeoPois } from '../../store/seo/seo-poi.actions'
import { selectCitiesToDiscoverLinks } from '../../store/seo/seo.selectors'
import { setSeoCitiesToDiscoverLinks } from '../../store/seo/seoSlice'
import { isEmpty } from '../../utils/lang'
import { handleRouteLoading } from '../routeService'

export const onRouteEnter = ({ store: { dispatch, getState } }) =>
  Promise.all([
    dispatch(activateGeoIp()),
    dispatch(resetAddress()),
    dispatch(resetSearchTerms()),
    dispatch(setItineraryDepartureNow()),
    loadHomePageData(dispatch, getState)
  ])

export const loadHomePageData = (dispatch, getState) =>
  Promise.resolve()
    .then(() => {
      const locale = selectLocale(getState())
      if (__SERVER__) {
        if (localeCountryIsFrance(locale)) {
          return Promise.all([
            searchFirstCities({ offset: COUNT_CITIES_TO_DISCOVER, limit: COUNT_CITIES_FOOTER_HP })(dispatch, getState),
            loadCitiesToDiscover()(dispatch, getState),
            loadTopSeoPois()(dispatch, getState),
            loadPoiAssetsConfiguration()(dispatch, getState),
            loadCompleteGeoentitiesAtAddressConfiguration()(dispatch, getState),
            loadFakeActivitiesForHp()(dispatch)
          ])
        } else if (localeCountryIsBelgium(locale)) {
          return Promise.all([
            searchFirstCities({ offset: COUNT_CITIES_TO_DISCOVER, limit: COUNT_CITIES_FOOTER_HP })(dispatch, getState),
            loadCitiesToDiscover()(dispatch, getState)
          ])
        }
      }
      if (__BROWSER__ && (localeCountryIsFrance(locale) || localeCountryIsBelgium(locale))) {
        const noCitiesToDiscoterLinks = isEmpty(selectCitiesToDiscoverLinks(getState()))
        if (noCitiesToDiscoterLinks) {
          return fetchSeoLinks(FRONT_SERVICES_LINK_HP).then(links => {
            if (links) {
              dispatch(setSeoCitiesToDiscoverLinks(links))
            }
          })
        }
      }
    })
    .catch(e => {
      console.error('Error while fetching data for footer, failing silently', e)
    })

export default handleRouteLoading({ onRouteEnter, renderPage })
